module.exports = __webpack_public_path__ + "img/measurement_info_left_top.1af5c624.jpg";